module.exports = __webpack_public_path__ + "static/media/50.27777921.webp";